import { useState, useRef, useEffect } from 'react'
import { api } from '../../../../../../services/api'
import { Button } from '../../../../../Button'
import { InputDate } from '../../../../../Forms/InputDate'
import { InputCheck } from '../../../../../Forms/InputCheck'
import { InputGeneric } from '../../../../../Forms/InputGeneric'
import { DotTypingLoader } from '../../../../../loaders/dotTypingLoader'
import { toast } from 'react-toastify'
import { useClube } from '../../contextClube'
import { Header } from '../Header'
import { FaCloudUploadAlt } from 'react-icons/fa'
import S3 from 'react-aws-s3';
import moment from 'moment';

import { Container, Content, Form, ImageUploader } from './style';


const config = {
    bucketName: 'portal.inoveclube',
    region: 'sa-east-1',
    dirName: '',
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
}


export function ModalFormsMainPageProperties() {
    const {  
        modalFormsMainIsOpen, 
        setModalFormsMainIsOpen, 
        pushingMainPageProperties,
        mainPageToEdit, setMainPageToEdit,
        editMainPageProperties 
    } = useClube()

    const [bgColorHeader, setBgColorHeader] = useState('#000000')
    const [bgColorBody, setBgColorBody] = useState('#000000')
    const [bgColorFooter, setBgColorFooter] = useState('#000000')
    const [fontsColorHeader, setFontsColorHeader] = useState('#000000')
    const [fontsColorBody, setFontsColorBody] = useState('#000000')
    const [fontsColorFooter, setFontsColorFooter] = useState('#000000')
    const [borderCardColor, setBorderCardColor] = useState('#000000')
    const [primaryCardFontColor, setPrimaryCardFontColor] = useState('#000000')
    const [secondaryCardFontColor, setSecondaryCardFontColor] = useState('#000000')

    const [title, setTitle] = useState('')
    const [loading, setLoading] = useState(false)

    const [initDate, setInitDate] = useState('')
    const [lastDate, setLastDate] = useState('')
    const [inputCheck, setInputCheck] = useState(false)

    const [img, setImg] = useState(null)
    const [imgName, setImgName] = useState('')
    const [imgFile, setImgFile] = useState(null)
    const inputFileRef = useRef(null)

    const ReactS3Client = new S3(config);
    const newFileName = moment(new Date()).format('DD-MM-YYYY') + imgName
    

    function dateSanitation (date){
        const dateSplit = new Date(date).toLocaleDateString('pt-BR', {timeZone: 'UTC'}).split('')
        return `${dateSplit[6] + dateSplit[7] + dateSplit[8] 
            + dateSplit[9] + '-' + dateSplit[3] 
            + dateSplit[4] + '-' + dateSplit[0] + dateSplit[1]}` 
    }

    function handleCheckInput() {
        setInputCheck(!inputCheck)
    }

    function clearImg() {
        setImg(null)
        setImgName('')
        inputFileRef.current.value = ''
    }

    function handleChooseFile() {
        inputFileRef.current.click()
    }

    function convertImg(file) {
        setImgFile(file)
        if(file){
          const reader = new FileReader()
          reader.onload = function() {
            setImg(reader.result)
          }
          reader.readAsDataURL(file)
          setImgName(file.name)
        }
    }

    function checkFileType(file) {
        let ext = file.value.match(/\.(.+)$/)[1];
        let fileNameLength = file.files[0].name.split('').length

        if(fileNameLength > 30){
            toast.warning('⚠️ O nome da imagem deve conter até 30 caracteres')
            inputFileRef.current.value = ''
            return
        }

        switch (ext) {
            case 'jpg':
            case 'jpeg':
            case 'png':
                convertImg(file.files[0])
                break
            default:
                toast.warning('⚠️ Tipo de arquivo não aceito')
                inputFileRef.current.value = ''
        }
    }


    async function handleCreateMainPageProperties(location) {
        setLoading(true)
        const obj = {
            bgColorHeader,
            bgColorBody,
            bgColorFooter,
            fontsColorHeader,
            fontsColorBody,
            fontsColorFooter,
            borderCardColor,
            primaryCardFontColor,
            secondaryCardFontColor,
            initDate,
            lastDate,
            deadline: !inputCheck,
            active: false,
            imageName: imgName,
            imageHeader: location,
            title
        }

        try{
            if(title === '' || initDate === '')
                throw new Error('Preencha todos os campos')

            if(inputCheck === false && lastDate === '')
                throw new Error('Publicação com prazo precisa de data de expiração')

            const response  = await api.post('/createMainPageProperties', obj, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const { success, message, objectCreated } = response.data
        
            if(success){
                pushingMainPageProperties(objectCreated)
                setModalFormsMainIsOpen(false)
                toast.success(message)
            }
            else
                toast.error(message)

            setLoading(false)
        }catch(error){
            setLoading(false)
            toast.error(error.message)
            toast.error(error)
        }
    }

    async function handleUpdateMainPageProperties(location) {
        const obj = {
            id: mainPageToEdit.id,
            bgColorHeader,
            bgColorBody,
            bgColorFooter,
            fontsColorHeader,
            fontsColorBody,
            fontsColorFooter,
            borderCardColor,
            primaryCardFontColor,
            secondaryCardFontColor,
            initDate,
            lastDate,
            deadline: !inputCheck,
            active: true,
            imageName: imgName,
            imageHeader: location,
            title
        }

        try{
            if(title === '' || initDate === '')
                throw new Error('Preencha todos os campos')

            if(inputCheck === false && lastDate === '')
                throw new Error('Publicação com prazo precisa de data de expiração')

            const response  = await api.put('/updateMainPageProperties', obj, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const { success, message } = response.data
        
            if(success){
                editMainPageProperties(obj)
                setModalFormsMainIsOpen(false)
                toast.success(message)
            }
            else
                toast.error(message)

            setLoading(false)
        }catch(error){
            setLoading(false)
            toast.error(error.message)
            toast.error(error)
        }
    }


    function handleSaveS3Image() {
        if(img === null){
            toast.error('Selecione uma imagem')
            return
        } 

        if(img !== null && img.slice(0, 8) === 'https://'){
            handleUpdateMainPageProperties(img)
            setLoading(true)
            return
        }

        setLoading(true)
        ReactS3Client
            .uploadFile(imgFile, newFileName)
            .then(data =>  mainPageToEdit === null ? handleCreateMainPageProperties(data.location) : handleUpdateMainPageProperties(data.location))
            .catch(err => {
                toast.error('Erro de envio de imagem')
                setLoading(false)
            })
    } 

    
    useEffect(() => {
        if(modalFormsMainIsOpen === false){
            setTitle('')
            setBgColorHeader('#000000')
            setBgColorBody('#000000')
            setBgColorFooter('#000000')
            setFontsColorHeader('#000000')
            setFontsColorBody('#000000')
            setFontsColorFooter('#000000')
            setBorderCardColor('#000000')
            setPrimaryCardFontColor('#000000')
            setSecondaryCardFontColor('#000000')
            setInitDate('')
            setLastDate('')
            setInputCheck(false)
            setImg(null)
            setImgName('')
            setImgFile(null)
            setMainPageToEdit(null)
            inputFileRef.current.value = ''
        }
    }, [modalFormsMainIsOpen, setMainPageToEdit])

    useEffect(() => {
        if(mainPageToEdit !== null){
            setTitle(mainPageToEdit.title)
            setBgColorHeader(mainPageToEdit.bgColorHeader)
            setBgColorBody(mainPageToEdit.bgColorBody)
            setBgColorFooter(mainPageToEdit.bgColorFooter)
            setFontsColorHeader(mainPageToEdit.fontsColorHeader)
            setFontsColorBody(mainPageToEdit.fontsColorHeader)
            setFontsColorFooter(mainPageToEdit.fontsColorFooter)
            setBorderCardColor(mainPageToEdit.borderCardColor)
            setPrimaryCardFontColor(mainPageToEdit.primaryCardFontColor)
            setSecondaryCardFontColor(mainPageToEdit.secondaryCardFontColor)
            setInitDate(dateSanitation(mainPageToEdit.initDate))
            setLastDate(mainPageToEdit.lastDate === null ? '' : dateSanitation(mainPageToEdit.lastDate))
            setInputCheck(!mainPageToEdit.deadline)
            setImg(mainPageToEdit.imageHeader)
            setImgName(mainPageToEdit.imageName)
        }
    }, [mainPageToEdit])

    useEffect(() => {
        if(inputCheck)
            setLastDate('')
    }, [inputCheck])
    

    return(
        <Container modalFormsMainIsOpen={modalFormsMainIsOpen}>
            <Content>
                <Header title={'Configurações Gerais'}  setModalFormsIsOpen={setModalFormsMainIsOpen}/>
                
                <Form>
                    <InputGeneric 
                        color="#7A05A7"
                        type="text"
                        placeholder="Título"
                        value={title}
                        onChange={event => setTitle(event.target.value)}
                    />

                    <h3>Cores de Fundo</h3>
                    <div className="backgrounds">
                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={bgColorHeader}
                                onChange={event => setBgColorHeader(event.target.value)}
                            />
                            <p>Cabeçalho</p>
                        </div>

                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={bgColorBody}
                                onChange={event => setBgColorBody(event.target.value)}
                            />
                            <p>Corpo</p>
                        </div>

                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={bgColorFooter}
                                onChange={event => setBgColorFooter(event.target.value)}
                            />
                            <p>Rodapé</p>
                        </div>
                    </div>

                
                    <h3>Cores de Fontes</h3>
                    <div className="fonts">
                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={fontsColorHeader}
                                onChange={event => setFontsColorHeader(event.target.value)}
                            />
                            <p>Cabeçalho</p>
                        </div>

                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={fontsColorBody}
                                onChange={event => setFontsColorBody(event.target.value)}
                            />
                            <p>Corpo</p>
                        </div>

                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={fontsColorFooter}
                                onChange={event => setFontsColorFooter(event.target.value)}
                            />
                            <p>Rodapé</p>
                        </div>
                    </div>


                    <h3>Cards de Empresas</h3>
                    <div className="fonts">
                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={borderCardColor}
                                onChange={event => setBorderCardColor(event.target.value)}
                            />
                            <p>Bordas</p>
                        </div>

                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={primaryCardFontColor}
                                onChange={event => setPrimaryCardFontColor(event.target.value)}
                            />
                            <p>Título</p>
                        </div>

                        <div>
                            <input 
                                type="color" 
                                className="colorInput"
                                value={secondaryCardFontColor}
                                onChange={event => setSecondaryCardFontColor(event.target.value)}
                            />
                            <p>Informações</p>
                        </div>
                    </div>

                    <ImageUploader img={img}>
                        <div className="imageArea">
                                <span 
                                    className="closeButton"
                                    onClick={clearImg}
                                >
                                    &#10006;
                                </span>
                                
                                {
                                    img === null ?
                                    <>
                                        <FaCloudUploadAlt />
                                        <p>Sem imagem</p>
                                    </>
                                    :<></>
                                }

                                <div className="fileName">
                                    <span>{imgName}</span>
                                </div>

                            
                                <img src={img} alt="imageFile"/> 
                        </div>

                        <button onClick={handleChooseFile}>
                            Upload
                        </button>

                        <input 
                            type="file"
                            accept="image"
                            ref={inputFileRef}
                            onChange={event => checkFileType(event.target)}
                            hidden
                        />
                    </ImageUploader>
                    
                    <div className="dateInputs">
                        <InputDate 
                            type="date" 
                            value={initDate} 
                            onChange={event => setInitDate(event.target.value)}
                        />
                        <p>a</p>
                        <InputDate 
                            type="date" 
                            value={lastDate} 
                            active={!inputCheck}
                            onChange={event => setLastDate(event.target.value)}
                        />
                    </div>
                    
                    <div className="inputText">
                        <InputCheck 
                            checked={inputCheck}
                            handleClick={handleCheckInput}
                        />
                        <p>Sem prazo</p>
                    </div>
                    
                </Form>

                <Button 
                    background="#7A05A7"
                    color="#FFF"
                    onClick={handleSaveS3Image}
                >
                    {
                        loading ? 
                        <DotTypingLoader />
                        :
                        'Publicar'
                    }
                </Button>
            </Content>
        </Container>
    )
}